import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/providers/Auth';
import { ThemeProvider } from '@/providers/Theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BreadcrumbProvider } from './providers/Breadcrumb';
import { ProviderElementsSelecteds } from './providers/ElementsSelecteds';
import { PermittionProvider } from './providers/Permition';
import { CookiesProvider } from 'react-cookie';
import { BranchProvider } from './providers/Branch';
import { ToastContainer } from 'react-toastify';
import { useInactivityLogout } from './hooks/useInactivityLogout';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});  

export function Root() {
  useInactivityLogout();
  return (
    <CookiesProvider>
      <AuthProvider>
        <ThemeProvider>
          <ToastContainer style={{ zIndex: 99999 }} />
          <QueryClientProvider client={queryClient}>
            <BreadcrumbProvider>
              <PermittionProvider>
                <ProviderElementsSelecteds>
                  <BranchProvider>
                    <Outlet />
                  </BranchProvider>
                </ProviderElementsSelecteds>
              </PermittionProvider>
            </BreadcrumbProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </AuthProvider>
    </CookiesProvider>
  );
}
